export enum UserLocalStorageKeys {
  privileges = "user-privileges",
  userId = "user-id",
  firstName = "first-name",
  lastName = "last-name",
}
